import React, { useState } from "react";
import "../assets/css/RegionSelectionSidebar.css";
import Dropdown from "../Pages/Dropdown.js";
import { useNavigate } from "react-router-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";

const Sidebar = ({
  selectedRegionalState,
  handleRegionalStateChange,
  selectedZone,
  handleZoneChange,
  zonesForState,
  selectedWoreda,
  handleWoredaChange,
  woredasForZone,
  selectedKebele,
  handleKebeleChange,
  kebelesForWoreda,
  regional_state,
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const getDashboardName = () => {
    if (selectedRegionalState && !selectedZone) return `${'regionalState' + ':' + selectedRegionalState}`;
    if (selectedKebele) return `${'kebele' + ':' + selectedKebele}`;
    if (selectedWoreda) return `${'woreda' + ':' + selectedWoreda}`;
    if (selectedZone) return `${'zone' + ':' + selectedZone}`;
    return null;
  };
  const dashboardName = getDashboardName();

  const handleDashboardClick = () => {
    const name = getDashboardName();
    if (name) {
      navigate("/dashboard", { state: { locationName: name } });
    }
  };


  return (
    <>
      <button
        className="sidebar-toggle-btn"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {mobileOpen ? "Close" : "Open"} Menu
      </button>

      <aside className={`sidebar ${mobileOpen ? "open" : ""}`}>
        <div className="sidebar-section">
          <div className="sidebar-header">LOCATION SELECTION</div>

          {/* Country */}
          <div className="ns-field-group">
            <label className="ns-label" htmlFor="country">
              Country
            </label>
            <select
              id="country"
              name="country"
              disabled
              className="ns-input-location no-arrow"
              autoComplete="off"
            >
              <option value="Ethiopia">🇪🇹 Ethiopia</option>
            </select>
          </div>

          {/* Regional State */}
          <div className="ns-field-group">
            <div className="ns-label">Regional State</div>
            <div className="ns-dropdown-row">
              <Dropdown
                options={regional_state.map((rs) => rs.regionalState).sort()}
                value={selectedRegionalState}
                onChange={handleRegionalStateChange}
                placeholder="Select Regional State"
              />
              {selectedRegionalState && (
                <AiOutlineCloseCircle
                  onClick={() =>
                    handleRegionalStateChange({ target: { value: "" } })
                  }
                  style={{
                    cursor: "pointer",
                    color: "black",
                    fontSize: "1.1rem",
                  }}
                  title="Clear Regional State"
                />
              )}
            </div>

          </div>

          {/* Zone */}
          {selectedRegionalState && (
            <>
              {zonesForState.length > 0 ? (
                <div className="ns-field-group">
                  <div className="ns-label">Zone</div>
                  <div className="ns-dropdown-row">
                    <Dropdown
                      options={[...new Set(zonesForState)]}
                      value={selectedZone}
                      onChange={handleZoneChange}
                      placeholder="Select Zone"
                    />
                    {selectedZone && (
                      <AiOutlineCloseCircle
                        onClick={() =>
                          handleZoneChange({ target: { value: "" } })
                        }
                        style={{
                          cursor: "pointer",
                          color: "black",
                          fontSize: "1.1rem",
                        }}
                        title="Clear Zone"
                      />
                    )}
                  </div>

                </div>
              ) : (
                <div className="ns-description">
                  No zones available for this Regional State.
                </div>
              )}
            </>
          )}

          {/* Woreda */}
          {selectedZone && (
            <>
              {woredasForZone.length > 0 ? (
                <div className="ns-field-group">
                  <div className="ns-label">Woreda</div>
                  <div className="ns-dropdown-row">
                    <Dropdown
                      options={[...new Set(woredasForZone)]}
                      value={selectedWoreda}
                      onChange={handleWoredaChange}
                      placeholder="Select Woreda"
                    />
                    {selectedWoreda && (
                      <AiOutlineCloseCircle
                        onClick={() =>
                          handleWoredaChange({ target: { value: "" } })}
                        className="ns-clear-icon"
                        title="Clear Woreda"
                      />
                    )}
                  </div>
                </div>

              ) : (
                <div className="ns-description">
                  No woredas available for this Zone.
                </div>
              )}
            </>
          )}

          {/* Kebele */}
          {selectedWoreda && (
            <>
              {kebelesForWoreda.length > 0 ? (
                <div className="ns-field-group">
                  <div className="ns-label">Kebele</div>
                  <div className="ns-dropdown-row">
                    <Dropdown
                      options={[...new Set(kebelesForWoreda)]}
                      value={selectedKebele}
                      onChange={handleKebeleChange}
                      placeholder="Select Kebele"
                    />
                    {selectedKebele && (
                      <AiOutlineCloseCircle
                        onClick={() =>
                          handleKebeleChange({ target: { value: "" } })
                        }
                        style={{
                          cursor: "pointer",
                          color: "black",
                          fontSize: "1.1rem",
                        }}
                        title="Clear Kebele"
                      />
                    )}
                  </div>

                </div>
              ) : (
                <div className="ns-description">
                  No kebeles available for this Woreda.
                </div>
              )}
            </>
          )}

          {selectedRegionalState && (
            <div className="ns-field-group" style={{ marginTop: "1rem" }}>
              <button
                onClick={handleDashboardClick}
                className="ns-dashboard-btn"
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  padding: "10px 14px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  width: "100%",
                  fontWeight: "500",
                }}
              >
                {dashboardName.replace('regionalState:', ' ').replace('zone:', ' ').replace('woreda:', ' ').replace('kebele:', ' ')} Dashboard
              </button>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
